import React from 'react'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Select from 'react-select';
import $ from 'jquery';
import {renderFieldNumerosPorcentagem, required, tamanhoPorcentagem} from '../../util/inputs';
import cadastrarImpostoEmpresa from '../../actions/imposto-empresa/cadastrarImpostoEmpresa';
import alterarImpostoEmpresa from '../../actions/imposto-empresa/alterarImpostoEmpresa';
import excluirImpostoEmpresa from '../../actions/imposto-empresa/excluirImpostoEmpresa';
import ImpostoEmpresa from './ImpostoEmpresa';
import {showSuccessMsg} from '../../util/messagesUtil';

export const validate = (values) => {
  const errors = {};
  if (!values.nome) {
    errors.nome = 'Campo obrigatório'
  }
  if (!values.email) {
    errors.email = 'Campo obrigatório'
  }

  return errors
};

export const CabecalhoTabelaImpostoEmpresa = () => (
    <div id="header-tabela" className="lista-table">
      <div className="row cabecalho-desktop">
        <div className="col-lg-6 col-xl-6">Imposto</div>
        <div className="col-lg-2 col-xl-2">Alíquota</div>
        <div className="col-lg-2 col-xl-2">Desconto</div>
        <div className="col-lg-2 col-xl-2">Ação</div>
      </div>
    </div>
);



export class modalImpostoEmpresa extends React.Component {
  constructor (props) {
    super(props);
    this.fechar = this.fechar.bind(this);
    this.submit = this.submit.bind(this);
    this.state = { impostoSelecionado: null }

  }

  montarParametroUsuario (values) {
    return {
      id: values.id,
      siglaImposto: this.state.impostoSelecionado.value,
      aliquota: values.aliquota,
      desconto: values.desconto,
      codigoEmpresa: this.props.empresa.id

    };
  }

  excluirImpostoEmpresa (id) {
    this.props.excluirImpostoEmpresa(id).then(resp => {
      if (resp.payload.status === 200) {
        this.props.buscarImpostosEmpresa(this.props.empresa.id);
      }
    })
  }

  submit (values) {
    this.props.cadastrarImpostoEmpresa(this.montarParametroUsuario(values))
      .then(() => {
          showSuccessMsg('Imposto cadastrado com sucesso');
          this.props.buscarImpostosEmpresa(this.props.empresa.id);
          this.fechar();
      })
  }

  fecharModal () {
    $('#modalImpostoEmpresa')
      .modal('hide');
    $('#modalImpostoEmpresa')
      .hide();
    $('.modalImpostoEmpresa')
      .hide();
  }

  fechar () {
    this.props.reset('frmImpostoEmpresa');
    this.setState({ impostoSelecionado: null })

    this.props.changeFieldValue('frmImpostoEmpresa',
      'desconto', '');

    this.props.changeFieldValue('frmImpostoEmpresa',
      'alilquota', '');

    this.props.changeFieldValue('formImpostoEmpresa',
      'impostoEmpresa.siglaImposto', null);
  }

  selecionarImposto(imposto){
    this.setState({ impostoSelecionado: imposto})
  }

  exibirComboImpostos (event) {
    return (
        <div>
          <Select
              {...event.input}
              noOptionsMessage={() => ('Nenhuma opção encontrada')}
              placeholder='Selecione um imposto...'
              options={this.props.impostos.map(elemento => (
                  {
                    label: elemento.sigla,
                    value: elemento.sigla
                  }))}
              onChange={value => this.selecionarImposto(value)}
              value={this.state.impostoSelecionado}
          />
          {event.meta.touched
          && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
        </div>
    )
  }

  exibirImpostoEmpresa () {
    if(!this.props.impostosEmpresa){
      return 'Não existem imposto cadastrado para empresa.'
    }
    return this.props.impostosEmpresa
        .map((impostoEmpresa, index) => <ImpostoEmpresa
          excluirImpostoEmpresa={this.excluirImpostoEmpresa.bind(this)}
          key={index} impostoEmpresa={impostoEmpresa}
          indice={index}/>)
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade show" id='modalImpostoEmpresa' role='dialog'
           aria-labelledby='modalImpostoEmpresa' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>Novo Imposto empresa</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                      onClick={() => this.fechar()}>
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-row">
                  <div className='col-10 col-sm-10 col-md-8'>
                    <Field name='imposto' component={this.exibirComboImpostos.bind(this)}/>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12 col-sm-4 col-md-4">
                    <Field name='aliquota' validate={[required, tamanhoPorcentagem]} component={renderFieldNumerosPorcentagem}
                           css="form-control" label="Aliquota do imposto (%)"/>
                  </div>
                  <div className="col-12 col-sm-4 col-md-4">
                    <Field name='desconto' validate={[required, tamanhoPorcentagem]} component={renderFieldNumerosPorcentagem}
                           css="form-control" label="Desconto para o imposto (%)"/>
                  </div>
                  <div className="col-12 col-sm-4 col-md-4">
                    <div className='mt-2'>
                      <button id="btn-salvar"
                              type="submit" disabled={invalid || submitting || pristine}
                              className="btn btn-laranja mt-4">Incluir
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <CabecalhoTabelaImpostoEmpresa/>
              <div className="lista-table">
                {this.exibirImpostoEmpresa()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarImpostoEmpresa,
    alterarImpostoEmpresa,
    excluirImpostoEmpresa
  }, dispatch)
);

export default connect(null, mapDispatchToProps)(reduxForm({
  form: 'frmImpostoEmpresa'
})(modalImpostoEmpresa));
